{
    "action__edit": "Edit",
    "action__copy_contact": "Copy contact"
}
